import ValueDeserializerInterface from "./ValueDeserializerInterface"
import { SerializedValueType } from "../../Model/Value/ValueInterface"
import NumberValue from "../../Model/Value/NumberValue"

export default class NumberValueDeserializer implements ValueDeserializerInterface {
  public supports(payload: SerializedValueType): boolean {
    return payload.type === "number"
  }

  public deserialize(payload: SerializedValueType): NumberValue {
    return new NumberValue(payload.payload.value)
  }
}
